import React from "react";
import HomeBanner from '../Components/HomeBanner';
import HomeCardService from "../Components/HomeCardService";
import HomeFeatures from "../Components/HomeFeatures";
import HomePackages from "../Components/HomePackages";
import HomePackagesLayout from "../Components/HomePackagesLayout";
//import HomeAbout from "../Components/HomeAbout";
import HomeMobileCardLayout from "../Components/HomeMobileCardLayout";
import HomeHallLayout from "../Components/HomeHallLayout";
import HomeTestimonialCardLayout from "../Components/HomeTestimonialCardLayout";
import HomeFaqsection from "../Components/HomeFaqSection";
import { Box } from "@mui/material";

const Home = () => {
  return (
    <Box sx={{ display: "block" }}>
      <HomeBanner />
      {/* <HomeCardService /> */}
      <HomeFeatures />
      <HomePackagesLayout />
      <HomeMobileCardLayout />
      {/* <HomeHallLayout /> */}
      <HomeTestimonialCardLayout />
      <HomeFaqsection />
    </Box>
  );
};

export default Home;